import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import PlayTrailer from '@jwp/ott-theme/assets/icons/play_trailer.svg?react';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const MediaButtonTrailer = ({
  hasTrailer,
  trailerItem,
  isTrailerPlaying,
  onClick,
  ...buttonProps
}: {
  hasTrailer: boolean;
  trailerItem: PlaylistItem | undefined;
  isTrailerPlaying: boolean;
  onClick: () => void;
  fullWidth?: boolean;
}) => {
  const { t } = useTranslation('video');

  if (!hasTrailer) {
    return null;
  }

  return (
    <Button
      label={t('video:trailer')}
      aria-label={t('video:watch_trailer')}
      startIcon={<Icon icon={PlayTrailer} />}
      onClick={onClick}
      active={isTrailerPlaying}
      disabled={!trailerItem}
      {...buttonProps}
    />
  );
};

export default MediaButtonTrailer;
